import * as React from "react"
import type { SVGProps } from "react"
const SvgHeading6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 17.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-8q0-.43.29-.72A1 1 0 0 1 4 7.86q.42 0 .71.28.3.3.29.72v3h4v-3q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v8q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-3H5v3q0 .42-.29.71a1 1 0 0 1-.71.29m11 0q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41v-6q0-.82.59-1.41a2 2 0 0 1 1.41-.6h5q.42 0 .71.3.3.28.29.7 0 .44-.29.72a1 1 0 0 1-.71.29h-5v2h4q.83 0 1.41.58.6.6.59 1.42v2q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm0-4v2h4v-2z" />
  </svg>
)
export default SvgHeading6
